import "react-app-polyfill/stable";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { ErrorBoundary, FallbackProps } from "react-error-boundary";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import { Android } from "./models/mobile/android";
import { actions, persistor, store } from "./redux";
import setupAxios from "./setup/setupAxios";
import { ClearCacheProvider } from "react-clear-cache";

const { PUBLIC_URL } = process.env;

declare global {
    interface Window {
        android: Android;
        // Вызывается из нативного слоя, когда foreground-сервис геолокации успешно стартовал
        // после асинхронного выдачи разрешений пользователем.
        onAndroidLocationServiceStarted?: () => void;
    }
}

const AppErrorFallback: React.FC<FallbackProps> = ({ error }) => {
    const err = error as Error;
    return (
        <div style={{ padding: 16, fontFamily: "monospace", fontSize: 12 }}>
            <b>Ошибка приложения:</b>
            <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-all" }}>Внутренняя ошибка</pre>
        </div>
    );
};

setupAxios(axios, store);

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
    <ErrorBoundary FallbackComponent={AppErrorFallback}>
        <Provider store={store}>
            <ClearCacheProvider duration={20 * 60 * 1000}>
                {/* TODO: Сделать красивый спиннер */}
                <PersistGate
                    persistor={persistor}
                    loading={<div>Загрузка...</div>}
                    onBeforeLift={() => {
                        const token = window.android?.getAuthToken?.();
                        if (token) store.dispatch(actions.authorize(token));
                    }}
                >
                    <App basename={PUBLIC_URL} />
                </PersistGate>
            </ClearCacheProvider>
        </Provider>
    </ErrorBoundary>,
);
